import { create } from 'zustand';

import { IS_WHITE_LABEL } from '@/shared/environments';
import { computeVariant, ExperimentVariant } from '@/shared/lib/abTest';

export const PAYWALL_EXPERIMENT_KEY = 'paywall.design_routing_sep_2026';

type PaywallExperimentState = {
  exposed: boolean;
  feature?: string;
  forced: boolean;
  userId?: string;
  variant: ExperimentVariant;
};

const control: PaywallExperimentState = { exposed: false, forced: false, variant: 'A' };
export const usePaywallExperimentStore = create<PaywallExperimentState>(() => control);

export const resolvePaywallVariant = (userId: string, url: string) => {
  const { hostname, searchParams } = new URL(url);
  const override = searchParams.get('paywall_variant');
  const forced =
    ['127.0.0.1', 'app.qa.rask.ai', 'localhost'].includes(hostname) && (override === 'A' || override === 'B');

  return { forced, variant: forced ? override : computeVariant(PAYWALL_EXPERIMENT_KEY, userId, undefined) };
};

export const resetPaywallExperiment = () => usePaywallExperimentStore.setState(control, true);

export const configurePaywallExperiment = (userId: string | undefined, eligible: boolean) => {
  if (IS_WHITE_LABEL || !userId || !eligible) {
    resetPaywallExperiment();
    return;
  }
  if (usePaywallExperimentStore.getState().userId === userId) return;
  usePaywallExperimentStore.setState({ ...control, ...resolvePaywallVariant(userId, window.location.href), userId }, true);
};

// Assignment is not exposure. Call only once the feature paywall is actually rendered.
export const exposePaywallExperiment = (feature: string) => {
  const { exposed, userId } = usePaywallExperimentStore.getState();
  if (!userId) return false;
  usePaywallExperimentStore.setState({ exposed: true, feature });
  return !exposed;
};

export const paywallExperimentProperties = () => {
  const { exposed, feature, forced, userId, variant } = usePaywallExperimentStore.getState();
  return exposed && userId
    ? {
        paywall_experiment_key: PAYWALL_EXPERIMENT_KEY,
        paywall_experiment_variant: variant,
        paywall_feature: feature,
        ...(forced ? { paywall_experiment_forced: true } : {}),
      }
    : {};
};
